import { getCustomChartType } from "../../helpers/chart/get-custom-chart-type";
import { useCustomPortfolioReturnsController } from "../../hook/use-custom-portfolio-returns-controller";
import { useTimeFrameController } from "../../hook/use-timeframe-controller";
import ChartComponent from "./ChartComponent";
import { getChartOptions } from "@/helpers/chart/get-chart-options";
import { ChartComponentParams } from "@/types/chart";

const ChartWrapper = ({
  symbols,
  chartKey,
  chartType,
  isControllable,
  rangeOptions,
  timeFrameOptions,
  range,
  timeFrame,
  title,
  valueFormatType,
  locale = "zh",
  currency,
  chart13FParams,
  customPortfolioParams,
  instanceData,
  instanceDataConfig,
  instanceLabels,
  className,
  customColorset,
  customChartOptions,
}: ChartComponentParams) => {
  const options = getChartOptions({
    chartKey,
    locale,
    title,
    valueFormatType,
    currency,
    instanceDataConfig,
    customColorset,
    customChartOptions,
  });

  const { currentRange, currentTimeFrame, TimeFrameController } =
    useTimeFrameController({
      lang: locale,
      isControllable,
      rangeOptions,
      timeFrameOptions,
      range,
      timeFrame,
    });

  const { CustomPortfolioReturnController, portfolioReturnsPeriod } =
    useCustomPortfolioReturnsController({
      lang: locale,
      chartKey,
    });

  const customChartType = getCustomChartType({
    chartKey,
    portfolioReturnsPeriod,
  });

  return (
    <div className="flex flex-col gap-5 w-full h-full">
      <TimeFrameController />
      <CustomPortfolioReturnController />
      <ChartComponent
        lang={locale}
        title={title}
        className={className}
        chartKey={chartKey}
        chartType={customChartType ? customChartType : chartType}
        options={options}
        symbols={symbols}
        range={currentRange}
        timeFrame={currentTimeFrame}
        chart13FParams={chart13FParams}
        customPortfolioParams={customPortfolioParams}
        customColorset={customColorset}
        portfolioReturnsPeriod={portfolioReturnsPeriod}
        instanceData={instanceData}
        instanceDataConfig={instanceDataConfig}
        instanceLabels={instanceLabels}
      />
    </div>
  );
};

export default ChartWrapper;
